import { Component, HostBinding, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'emp-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  imports: [NgTemplateOutlet]
})
export class SvgIconComponent {
  readonly icon = input<string>(undefined);

  @HostBinding('style.width')
  readonly width = input('20px');
  @HostBinding('style.height')
  readonly height = input(' 20px');
}
